import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { useSessionStore } from 'session/useSessionStore';

type StorageCallback = (params: {
  key: string | null;
  newValue: string | null;
  oldValue: string | null;
}) => void;

const useLocalStorageListener = (cb: StorageCallback) => {
    useEffect(() => {
        function handleStorage(e: StorageEvent) {
        // e.key === the key that changed, or null for clear()
            cb({
                key: e.key,
                newValue: e.newValue,
                oldValue: e.oldValue,
            });
        };

        window.addEventListener('storage', handleStorage);
        return () => window.removeEventListener('storage', handleStorage);
    }, [cb]);
};

export const GeopostSecureRoute = () => {
    const { jwt, setJwt  } = useSessionStore(state => ({
        jwt: state.jwtToken,
        setJwt: state.setJwtToken,
    }));

    useLocalStorageListener(({ key, newValue }) => {
        if (key === 'GeopostJWT' && !!newValue && newValue !== jwt ) {
            setJwt(newValue);
        }
    });

    return (
        <Outlet/>
    );
};